import * as React from 'react';
import { CheckboxList } from '@grandvisionhq/common';
import { useLink } from '@grandvisionhq/frk-routing';
import { useIntl, useSelector, useDispatch, statusFailed } from '@grandvisionhq/state';
import { parseHtml } from '@grandvisionhq/utils';
import { goto } from '../../actions.js';
import { getAuth } from '../../selectors.js';
import { isLoggedInPasswordless, isLoggedIn, isLoggedOut } from '../../state.js';
import { useSetPassword } from '../hooks/use-create-password.js';
import SetPassword from './SetPassword.js';
import { loginWithPassword } from '../../Login/actions.js';

const SetPasswordContainer = ({ consentItems  })=>{
    const { getLabel  } = useIntl();
    const auth = useSelector(getAuth);
    const dispatch = useDispatch();
    const [password1, setPassword] = React.useState('');
    const [alreadyLoggingIn, setAlreadyLoggingIn] = React.useState(false);
    const [setPasswordCall, { customerId , loading , error  }] = useSetPassword();
    // has to be used together with loading status from graphql for the call to have loading state until redirect is successful
    const [redirecting, setRedirecting] = React.useState(false);
    const { href: profileRoute  } = useLink({
        route: 'me.profile'
    }) || {};
    const { href: loginRoute  } = useLink({
        route: 'auth.login'
    }) || {};
    const labels = {
        title: getLabel('account.createAccount.title'),
        text: getLabel('account.passwordStrength.notStrongEnough'),
        error: getLabel('account.createAccount.error.consentRequired'),
        form: {
            password: getLabel('fields.input.password.label'),
            submit: getLabel('account.action.createAccount')
        }
    };
    const [selectedConsents, setSelectedConsents] = React.useState([]);
    const [hasErrors, setHasErrors] = React.useState(false);
    React.useEffect(()=>{
        if (error) setRedirecting(false);
    }, [
        error,
        setRedirecting
    ]);
    const consents = React.useMemo(()=>{
        if (!consentItems || consentItems.length === 0) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(CheckboxList, {
            idPrefix: "consent_",
            items: consentItems,
            renderItem: (item)=>/*#__PURE__*/ React.createElement("span", null, parseHtml(item.title))
            ,
            getItemIdentifier: (consent)=>consent.value
            ,
            selectedItems: selectedConsents,
            onChange: setSelectedConsents
        });
    }, [
        consentItems,
        selectedConsents
    ]);
    const handleSubmit = (password)=>{
        // Check if all consents were checked if there are any
        if (!consentItems.length || consentItems.every(({ value  })=>selectedConsents.map((c)=>c.value
            ).includes(value)
        )) {
            setPassword(password);
            setRedirecting(true);
            setPasswordCall({
                password,
                customerId: auth.userId,
                consents: selectedConsents,
                email: auth.email
            });
        } else {
            setHasErrors(true);
        }
    };
    const passwordlessErrorMessage = isLoggedInPasswordless(auth) && statusFailed(auth.activateCall) ? getLabel('account.createAccount.setPassword.errors.general') : undefined;
    const { href: profilePage  } = useLink({
        route: 'me.profile'
    }) || {};
    React.useEffect(()=>{
        if (isLoggedInPasswordless(auth) && customerId && !alreadyLoggingIn) {
            // set password was successful
            setAlreadyLoggingIn(true);
            dispatch(loginWithPassword({
                email: auth.email,
                password: password1,
                returnPath: profilePage || ''
            }));
        } else if (isLoggedIn(auth)) {
            dispatch(goto({
                route: profileRoute || ''
            }));
        } else if (isLoggedOut(auth)) {
            dispatch(goto({
                route: loginRoute || ''
            }));
        }
    }, [
        auth,
        dispatch,
        customerId,
        profileRoute,
        loginRoute
    ]);
    return /*#__PURE__*/ React.createElement(SetPassword, {
        labels: labels,
        consentItems: consents,
        onSubmit: handleSubmit,
        hasErrors: hasErrors || !!error,
        passwordlessErrorMessage: passwordlessErrorMessage,
        isLoading: loading || redirecting
    });
};
var SetPasswordContainer$1 = SetPasswordContainer;

export { SetPasswordContainer, SetPasswordContainer$1 as default };
//# sourceMappingURL=SetPasswordContainer.js.map
